import React from "react";
import { useField } from "formik";
import { CountryPreviewFragment } from "__generated__/graphql";
import { CustomCountriesField } from "customField/partials/fields/CustomCountriesField";

interface IFormikPreviewFormMultiAutoCompleteProps {
  name: string;
  labelledById?: string;
}
export const FormikPreviewFormMultiAutoComplete: React.FC<
  IFormikPreviewFormMultiAutoCompleteProps
> = ({ name, labelledById }) => {
  const [field, meta, helpers] = useField<string>({
    name,
  });

  const setValue = (value: CountryPreviewFragment[] | null) => {
    value && helpers.setValue(JSON.stringify(value));
  };
  const value = field.value
    ? (JSON.parse(field.value) as CountryPreviewFragment[])
    : [];

  return (
    <CustomCountriesField
      value={value}
      setValue={(newValue) => setValue(newValue)}
      labelledById={labelledById}
      errorMessage={meta.error}
      touched={meta.touched}
    />
  );
};
